// extracted by mini-css-extract-plugin
export var details = "_ju-0";
export var inspectorPopover = "_ju-1";